export default __webpack_public_path__ + "static/media/N.05bf64b9.svg";